import "./style.scss";
import { LeftBarProvider } from "./context/LeftBar";
import { ConfigProvider } from "./context/Config";
import Layout from "./pages/Layout";

function App() {
  return (
    <LeftBarProvider>
      <ConfigProvider>
        <Layout />
      </ConfigProvider>
    </LeftBarProvider>
  );
}

export default App;
